import { getHost } from 'services/EnvProvider';
import { isSimpleMiningUrl } from './isSimpleMiningUrl';

export const getMetaTranslationKey = () =>
  isSimpleMiningUrl() ? 'simpleMining' : 'simplePod';

export const getCanonicalUrl = (locale, subpage) =>
  (locale === 'en' && `https://${getHost()}/${subpage}`) ||
  `${getHost()}/${locale}/${subpage}`;
